/*
 Initial state and properties
 */
 export const initialState = {
    mode:"POST",
    supplierIdSelected:0,
    defaultDataSupplier:{}
 }
 /*
  Action types
  */
 export const SET_MODE = 'SET_MODE'
 export const SET_SUPPLIER_ID = 'SET_SUPPLIER_ID'
 export const SET_DEFAULT_DATA = 'SET_DEFAULT_DATA'
 /*
  Arrow function for change state
  */
 export const setMode = (payload) => ({
   type: SET_MODE,
   payload,
 });
 export const setSupplierId = (payload) => ({
  type: SET_SUPPLIER_ID,
  payload,
})
export const setDefaultDataSupplier = (payload) => ({
  type: SET_DEFAULT_DATA,
  payload,
})
 /*
  Reducer to describe how the state changed
  */
 export default function Reducer(state = initialState, { type, payload }) {
   switch (type) {
     case SET_MODE:
       return {
         ...state,
         mode: payload,
       }
       case SET_SUPPLIER_ID:
        return {
          ...state,
          supplierIdSelected: payload,
        }
        case SET_DEFAULT_DATA:
          return {
            ...state,
            defaultDataSupplier: payload,
          }
     default:
       return state
   }
 }
 